<script setup lang="ts">
import { onMounted } from 'vue';

interface Props {
  compromisso?: any;
}

const props = defineProps<Props>();

const emit = defineEmits(['loaded']);

onMounted(() => {
  emit('loaded');
});
</script>

<template>
  <a-descriptions
    v-if="props.compromisso.data"
    :column="3"
    :label-style="{ width: '35%' }"
    bordered
  >
    <a-descriptions-item label="Motivo" :span="3">
      {{ props.compromisso.data.motivoText }}
    </a-descriptions-item>
    <a-descriptions-item label="GCPJ" :span="3">
      {{ props.compromisso.data.gcpj }}
    </a-descriptions-item>
  </a-descriptions>
</template>
